import { IconButton } from '@loadsmart/loadsmart-ui'
import { MessageRead } from 'common/types/kraken-core/Message'
import DirectionTag from 'atoms/DirectionTag/DirectionTag'
import TransactionTypeTag from 'atoms/TransactionTypeTag/TransactionTypeTag'
import TradingPartnerTag from 'atoms/TradingPartnerTag/TradingPartnerTag'
import { Grid, Tooltip } from '@mui/material'
import { OpenInNew } from '@mui/icons-material'
import analytics, { AnalyticsEvent, AnalyticsEventTrigger } from 'common/analytics'
import Icon from 'atoms/Icon'
import { toast } from 'react-toastify'

export interface MessageDetailHeaderProps {
  message: MessageRead
  className?: string
  showActions?: boolean
  onReload?: () => void
  onClose?: () => void
}

const MessageDetailHeader = ({
  message,
  showActions = false,
  onReload,
  onClose,
}: MessageDetailHeaderProps) => {
  // const context = useMessagesDashboardViewContext()
  const messageDetailsLink = `/messages/${message?.id}`

  return (
    <Grid container alignItems="center" wrap="nowrap" sx={{ justifyContent: 'space-between' }}>
      {/* Message Header */}
      <Grid item xs zeroMinWidth>
        <Grid container spacing={1} wrap="wrap">
          <Grid item>
            <TradingPartnerTag id={message.party.id} name={message.party.name} label="Party" />
          </Grid>
          <Grid item>
            <DirectionTag direction={message.direction} />
          </Grid>
          <Grid item>
            <TradingPartnerTag
              id={message.counterparty.id}
              name={message.counterparty.name}
              label="Counterparty"
            />
          </Grid>
          <Grid item>
            <TransactionTypeTag transaction_type={message.transaction_type} />
          </Grid>
        </Grid>
      </Grid>

      {/* Message actions */}
      {showActions && (
        <Grid item sx={{ flexShrink: 0 }}>
          <Grid container spacing={1} wrap="nowrap">
            <Grid item>
              <Tooltip title="Reload">
                <IconButton
                  onClick={e => {
                    analytics.event({
                      category: AnalyticsEvent.MessageDetailReload,
                      action: AnalyticsEventTrigger.click,
                    })
                    onReload?.()
                  }}
                  scale="default"
                >
                  <Icon name="retry" size={20} />
                </IconButton>
              </Tooltip>
            </Grid>

            <Grid item>
              <Tooltip title="Copy message link">
                <IconButton
                  onClick={e => {
                    analytics.event({
                      category: AnalyticsEvent.MessageDetailCopyLink,
                      action: AnalyticsEventTrigger.click,
                    })
                    navigator.clipboard.writeText(`${location.origin}${messageDetailsLink}`)
                    toast.info('Copied to clipboard')
                  }}
                  scale="default"
                >
                  <Icon name="copy" size={20} />
                </IconButton>
              </Tooltip>
            </Grid>

            <Grid item>
              <Tooltip title="Open full screen">
                <IconButton
                  onClick={e => {
                    analytics.event({
                      category: AnalyticsEvent.MessageDetailViewFullpage,
                      action: AnalyticsEventTrigger.click,
                    })
                    window.open(messageDetailsLink, '_blank')
                    e.preventDefault()
                  }}
                  scale="default"
                >
                  <OpenInNew />
                </IconButton>
              </Tooltip>
            </Grid>

            <Grid item>
              <Tooltip title="Close [Esc]">
                <IconButton
                  onClick={e => {
                    analytics.event({
                      category: AnalyticsEvent.MessageDetailClose,
                      action: AnalyticsEventTrigger.click,
                    })
                    if (onClose) onClose()
                  }}
                  scale="default"
                >
                  <Icon name="close" size={20} />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  )
}

export default MessageDetailHeader
